const api = 'https://ngo.friendbizgroup.com/api';

const ConfigApi = {
  // Auth
  LOGIN: `${api}/login`,
  REGISTER: `${api}/registration`,
  LOGOUT: `${api}/logout`,
  INIT:`${api}/activity/init`,

  // Common
  COMMON_ACC_LIST: `${api}/common/account/list`,
  BANK_LIST:`${api}/common/bank/list`,
  IMAGE_UPLOAD:`${api}/common/:userSl/image/upload`,
  // Order
  DASHBOARD_INFO: `${api}/dashboard/info`,

  //Member
  INVESTOR_LIST:`${api}/investor/list`,
  INVESTOR_CREATE:`${api}/investor/create`,
  INVESTOR_UPDATE:`${api}/investor/update`,

 //Collection
  COLLECTION_LIST:`${api}/collection/list`,
  COLLECTION_CREATE:`${api}/collection/create`,

  //Member
  MEMBER_LIST:`${api}/member/list`,
  MEMBER_CREATE:`${api}/member/create`,
  MEMBER_UPDATE:`${api}/member/update`,

  //Local Invest
  LOCAL_INVEST_LIST:`${api}/local-invest/list`,
  LOCAL_INVEST_CREATE:`${api}/local-invest/create`,
  LOCAL_INVEST_UPDATE:`${api}/local-invest/update`,
  //Local Invest
  OTHER_INVEST_LIST:`${api}/other-invest/list`,
  OTHER_INVEST_CREATE:`${api}/other-invest/create`,
  OTHER_INVEST_UPDATE:`${api}/other-invest/update`,
  OTHER_INVEST_COMPLETE:`${api}/other-invest/complete`,
  OTHER_INVEST_COLLECT:`${api}/other-invest/collect`,
  //Local Invest
  TRANSACTION_LIST:`${api}/finance/transaction/list`,
  TRANSACTION_CREATE:`${api}/finance/transaction/create`,
  TRANSACTION_UPDATE:`${api}/finance/transaction/update`,

  //Local Invest
  INCOME_LIST:`${api}/income/list`,
  INCOME_CREATE:`${api}/income/create`,
  INCOME_UPDATE:`${api}/income/update`,

  //Local Invest
  EXPENSE_LIST:`${api}/expense/list`,
  EXPENSE_CREATE:`${api}/expense/create`,
  EXPENSE_UPDATE:`${api}/expense/update`,
  //Finance Account
  ACCOUNT_TYPE_LIST:`${api}/finance/type/list`,
  ACCOUNT_LIST:`${api}/finance/account/list`,
  ACCOUNT_CREATE:`${api}/finance/account/create`,
  ACCOUNT_UPDATE:`${api}/finance/account/update`,
  ACCOUNT_EXPENSE_LIST:`${api}/common/expense/account/list`,

  //Profit Loss
  PROFIT_LOSS_INFO:`${api}/finance/profit-loss/info`,
  PROFIT_LOSS_DISBURSE:`${api}/finance/profit-loss/disburse`,


};

export default ConfigApi;
